import { useEffect, useState } from "react";
import quizAPI from "../../libs/api/quiz";
import { getQuizId } from "../../App";
import { AccountType } from "../constants/constants";
import { QuizyUrl } from "../../libs/env";

export default function CheckFeedbackStatus(
  IsFeedbackGenerating,
  setIsFeedbackGenerating,
  data,
  GradingToggle,
  setShowGradingbtn,
  GradeWithAI,
  isReview,
  setGradeWithAI
) {
  const [feedbackalert, setfeedbackalert] = useState(false);

  useEffect(() => {
    if (
      window.location.origin.includes(QuizyUrl) &&
      data &&
      data?.user_type !== AccountType.STUDENT &&
      data?.user_type !== AccountType.ANONYMOUSE_USER &&
      data?.ai_grading_task &&
      data?.ai_marking_scheme
    ) {
      setShowGradingbtn(true);
    }
    if (sessionStorage.getItem("popupShown")) {
      GradingToggle();
      sessionStorage.removeItem("popupShown");
      sessionStorage.setItem('showCancel', 'true');
    }
    if(isReview && GradeWithAI)
    {
      setGradeWithAI(false);
    }
  });

  useEffect(() => {
    if (IsFeedbackGenerating && data.user_type !== AccountType.STUDENT) {
      setfeedbackalert(true);
      setInterval(() => getFeedbackStatus(), 12000);
    }
  }, [data, IsFeedbackGenerating]);

  useEffect(() => {
    if (IsFeedbackGenerating || GradeWithAI) {
      window.addEventListener("beforeunload", genFeedbackalert);
      return () => {
        window.removeEventListener("beforeunload", genFeedbackalert);
      };
    }
  });

  const genFeedbackalert = (e) => {
    if (IsFeedbackGenerating && feedbackalert) {
      e.preventDefault();
      e.returnValue = "";
    }
    else if (GradeWithAI && !isReview)
    {
      console.log(GradeWithAI);
      e.preventDefault();
      e.returnValue = "";
    }
  };
  function getFeedbackStatus() {
    quizAPI
      .get_ai_feedback_status({ id: getQuizId() })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          setfeedbackalert(false);
          setIsFeedbackGenerating(false);
          window.location.reload();
        }
      });
  }
}
